<div
  class="input-container"
  [class.focused]="focused"
  [class.error]="error"
  [class.success]="success"
  [class.disabled]="disabled"
  [class.readonly]="readonly"
>
  <div class="label-input">
    <div class="label" *ngIf="label">
      <div class="label-text">
        <span class="labeltext_span" [class.labeltext_span--error]="error">{{ label }}</span>
        <span class="required-asterisk" *ngIf="required">*</span>
      </div>
    </div>
    <div class="input" [class.hover]="!disabled">
      @if (prefix) {
        <div class="input__prefix">
          <span class="input__prefix-text">{{ prefix }}</span>
        </div>
      }
      <!-- Left Icon -->
      <div
        class="input__icon input__icon--left"
        *ngIf="iconLeft"
        [class.clickable]="onIconLeftClick.observed"
        (click)="onLeftIconClick($event)"
      >
        <ng-container *ngIf="iconLeftTemplate; else svgIconLeft">
          <ng-container *ngTemplateOutlet="iconLeftTemplate"></ng-container>
        </ng-container>
        <ng-template #svgIconLeft>
          <span [innerHTML]="sanitizedIconLeft"></span>
        </ng-template>
      </div>

      <ng-container *ngIf="!textarea; else textareaField">
        @if (prefix) {
          <input
            #inputElement
            class="input-field"
            type="text"
            [placeholder]="placeholder"
            [disabled]="disabled"
            [readonly]="readonly"
            [id]="id"
            [name]="name"
            [autocomplete]="autocomplete"
            [class.has-prefix]="prefix"
            [attr.maxlength]="maxlength"
            (focus)="onFocusHandler($event)"
            (blur)="onBlurHandler($event)"
            currencyMask
            [options]="{ prefix: '', thousands: '.', precision: 0, align: 'left' }"
            (ngModelChange)="onCurrencyChange($event)"
            [(ngModel)]="value"
          />
        } @else {
          <input
            #inputElement
            class="input-field"
            [type]="type"
            [value]="value"
            [placeholder]="placeholder"
            [disabled]="disabled"
            [readonly]="readonly"
            [id]="id"
            [name]="name"
            [autocomplete]="autocomplete"
            [attr.maxlength]="maxlength"
            (input)="onInput($event)"
            (focus)="onFocusHandler($event)"
            (blur)="onBlurHandler($event)"
          />
        }
      </ng-container>
      <ng-template #textareaField>
        <textarea
          class="input-field"
          [value]="value"
          [placeholder]="placeholder"
          [disabled]="disabled"
          [readonly]="readonly"
          [id]="id"
          [name]="name"
          [autocomplete]="autocomplete"
          [attr.maxlength]="maxlength"
          (input)="onInput($event)"
          (focus)="onFocusHandler($event)"
          (blur)="onBlurHandler($event)"
        ></textarea>
      </ng-template>
      <!-- Right Icon -->
      <div
        class="input__icon input__icon--right"
        *ngIf="iconRight"
        [class.clickable]="onIconRightClick.observed"
        (click)="onRightIconClick($event)"
      >
        <ng-container *ngIf="iconRightTemplate; else svgIconRight">
          <ng-container *ngTemplateOutlet="iconRightTemplate"></ng-container>
        </ng-container>
        <ng-template #svgIconRight>
          <span [innerHTML]="sanitizedIconRight"></span>
        </ng-template>
      </div>
    </div>
  </div>
  <div class="message" *ngIf="error">
    <div class="message-text">
      <span [class.error-message]="error" [class.hint-message]="!error">
        {{ error }}
      </span>
    </div>
  </div>
  <div class="message" *ngIf="hint && !error && !success">
    <div class="message-text">
      <span class="hint-message">
        {{ hint }}
      </span>
    </div>
  </div>
  <div class="message" *ngIf="success">
    <div class="message-text">
      <span class="success-message">
        {{ success }}
      </span>
    </div>
  </div>
</div>
